module.exports = __webpack_public_path__ + "static/media/coffee-02.6d760483.png";